// extracted by mini-css-extract-plugin
export default {"typingContainer":"styles_typingContainer__7S4dg"};